import React from 'react';
import {Paper, Table, TableBody, TableRow, TableRowColumn} from 'material-ui';
import {observer, inject} from 'mobx-react';
import {cmURL} from '../libs/config'
import TextTruncate from './common/TextTruncate';

@inject('contentStore')
@observer
class Publications extends React.Component {


    pdfTable = [
        {name:'Strengthening climate change adaptation through effective disaster risk reduction', url:'http://hydrology.gov.np/new/hydrology/_files/1752bc23b5ded4f38edcb7f63a3bd82e.pdf'},
        {name:'DIPECHO Nepal Newsletter July 2010', url:'http://hydrology.gov.np/new/hydrology/_files/5a428cd84feec42b45ace8b11e1879d1.pdf'},
        {name:'Web Based Real Time Data Acquisition System for Flood Early Warning', url:'http://hydrology.gov.np/new/hydrology/_files/da0cad41a0de4eef2292a05f06a2adeb.pdf'},
        {name:'Performance evaluation of WRF model for Nepal', url:'http://hydrology.gov.np/new/hydrology/_files/dbe7408750c5c54648ac8cf8d1135b30.pdf'},
        {name:'Flood Forecasting in Bagmati Basin using MIKE 11 model', url:'http://hydrology.gov.np/new/hydrology/_files/efa57c381519c85c482428163535f05a.pdf'},
        {name:'Customization of WRF model for Nepal', url:'http://hydrology.gov.np/new/hydrology/_files/2853be474fe029884e6081b6f823c870.pdf'},
        {name:'Downscaling WRF Model for Bagmati Basin', url:'http://hydrology.gov.np/new/hydrology/_files/6cff016903df9ab3a7c4406add07ccad.pdf'},
        {name:'Model Requirement for Different Sector', url:'http://hydrology.gov.np/new/hydrology/_files/93b65d0fa4c1c1d08f215863c69d3645.pdf'},
        {name:'Using satellite-based rainfall estimates for streamflow modelling: Bagmati Basin', url:'http://hydrology.gov.np/new/hydrology/_files/84f83017aa3416c4580ad52dfbff0607.pdf'},
        {name:"Establishing community based early warning system: facilitator's guide", url:'http://hydrology.gov.np/new/hydrology/_files/236d10264f3d1750ca54cdc88520db78.pdf'},
        {name:"Establishing community based early warning system: practitioner's handbook", url:'http://hydrology.gov.np/new/hydrology/_files/9a8425b638e7ad05eb8276bc22802456.pdf'},
        {name:'Determination of Threshold Runoff for Flood Warning in Nepalese Rivers', url:'http://hydrology.gov.np/new/hydrology/_files/d01e25a32d32c646f5475a35d22e05b9.pdf'},
        {name:'SPATIAL PATTERN IN THE PRECIPITATION REGIME OF NEPAL', url:'http://hydrology.gov.np/new/hydrology/_files/93aeb60c86418d8017731f95e4435482.pdf'},
        {name:'Community Based Approach to Flood Early Warning in West Rapti River Basin of Nepal', url:'http://hydrology.gov.np/new/hydrology/_files/5a2dc7c8c7966bf4b47cc951681e5726.pdf'},
        {name:'Real Time Data Analysis of West Rapti River Basin of Nepal', url:'http://hydrology.gov.np/new/hydrology/_files/c55c2a2fd5ea1b3362ee04eb80a0fb7e.pdf'},
        {name:'AGRO-CLIMATIC ATLAS OF NEPAL', url:'http://hydrology.gov.np/new/hydrology/_files/c94f417f99ea81fd4f0aff603959ae5f.pdf'},
        {name:'Rapid Assessment of Flood in Dudhkoshi River on 10th June 2015', url:'http://hydrology.gov.np/new/hydrology/_files/ea552929405a7a6ba57e8b887c7e3abd.pdf'},
        // {name:'Rising Precipitation Extremes across Nepal', url:''}

    ];

    render() {
      let publications = this.props.contentStore.publications;
      return(
        <div className="inline-it">
          <Paper zDepth={2}>
            <Table style={{maxWidth:'1000px'}}>
              <TableBody displayRowCheckbox={false} showRowHover={false} stripedRows={true}>{
                publications.length>0 && publications.map((item, index) => (
                  <TableRow selectable={false} key={index}>
                    <TableRowColumn style={{paddingTop:item.description==='5px'?'':'10px', whiteSpace:'normal'}}>
                      <a href={`${cmURL}/files/${item.file_name}`} target="_blank" rel="noopener noreferrer" className="content-title">{item.title}</a>
                      <TextTruncate text={item.description}/>
                    </TableRowColumn>
                  </TableRow>
                ))
              }</TableBody>
            </Table>
          </Paper>
        </div>
      );
    }
}

export default Publications;


// WEBPACK FOOTER //
// ./src/components/Publications.js